<template>
    <div class="menu-container">
        <div class="menu-list-box">
            <el-menu :default-openeds="defaultOpeneds" :default-active="defaultActive" background-color="#284077" 
                text-color="rgba(255,255,255,.7)" active-text-color="#4994FB" :unique-opened="true" 
                @select="handleMenuSelect" @open="handleMenuOpen" @close="handleMenuClose">
                <!-- 一级 -->
                <template v-for="(oneitem, i) in menuList">
                    <el-menu-item v-if="!oneitem.children || oneitem.children.length == 0" :key="i" 
                        :index="`${oneitem.path}-${oneitem.name}`">
                        <span slot="title">{{oneitem.name}}</span>
                    </el-menu-item>
                    <el-submenu v-else :key="i" :index="`${oneitem.path}-${oneitem.name}`" class="secondmenubox">
                        <template slot="title">{{oneitem.name}}</template>
                        <!-- 二级 -->
                        <template v-for="(twoitem, j) in oneitem.children">
                            <el-menu-item v-if="!twoitem.children || twoitem.children.length == 0" :key="j" 
                                :index="`${twoitem.path}-${twoitem.name}`">
                                <span slot="title">{{twoitem.name}}</span>
                            </el-menu-item>
                            <el-submenu v-else :key="j" :index="`${twoitem.path}-${twoitem.name}`" class="thirdmenubox">
                                <template slot="title">{{twoitem.name}}</template>
                                <!-- 三级 -->
                                <template v-for="(threeitem, k) in twoitem.children">
                                    <el-menu-item v-if="!threeitem.children || threeitem.children.length == 0" :key="k" 
                                        :index="`${threeitem.path}-${threeitem.name}-${threeitem.style}-${threeitem.id}`">
                                        <span slot="title">{{threeitem.name}}</span>
                                    </el-menu-item>
                                    <el-submenu v-else :key="k" :index="`${threeitem.path}-${threeitem.name}-${threeitem.style}-${threeitem.id}`" class="fourmenubox">
                                        <template slot="title">{{threeitem.name}}</template>
                                        <!-- 四级 -->
                                        <template v-for="(fouritem, l) in threeitem.children">
                                            <el-menu-item :key="l" :index="`${fouritem.id}-${fouritem.name}`">
                                                <span slot="title">{{fouritem.name}}</span>
                                            </el-menu-item>
                                        </template>
                                    </el-submenu>
                                </template>
                            </el-submenu>
                        </template>
                    </el-submenu>
                </template>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MenuComponent',
    data() {
        return {
            menuList: [], // 左侧菜单栏列表
            defaultActive: "", // 默认选中项
            defaultOpeneds: [], // 默认展开项
        }
    },
    created() {
        this.getMenuList();
        this.openBus();
    },
    mounted() {},
    methods: {
        /**
         * @function getMenuList 获取菜单列表数据
         */
        getMenuList() {
            // this.$axios.get(this.urls.menuList).then(res => {
            //     console.log(res);
            // });
            this.$axios.get('static/json/menu.json').then(res => {
                this.menuList = res.menuList;
                this.getColumnList();
            });
        },
        /**
         * @function getColumnList 获取栏目列表
         */
        getColumnList() {
            this.$axios.get(this.$urls.columnAllData, {
                params: {
                    from: 'backend'
                }
            }).then(res => {
                let data = res.result;
                let _data = JSON.parse(JSON.stringify(data));
                if(data.length > 0) {
                    _data.forEach(el => {
                        if(el.id == 7) {
                            // 政策扶持
                            el['path'] = '/policySupport';
                            el.children = [];
                        } else {
                            if(el.children && el.children.length > 0) {
                                el.children.forEach(cel => {
                                    cel['path'] = '/pageNull';
                                });
                            }
                        }
                        // el['path'] = el.id == 7 ? '/policySupport' : '/pageNull';
                    });
                }
                this.menuList[0].children = this.menuList[0].children.concat(_data);
                this.getSessionData();
                this.updateColumnList(data);
            });
        },
        /**
         * @function getSessionData 获取本地缓存的页面信息
         */
        getSessionData() {
            let data = window.sessionStorage.getItem('menuChecked');
            if(data) {
                let _data = JSON.parse(data);
                this.defaultOpeneds = _data.openedIndex;
                this.defaultActive = _data.activeIndex;
            }
        },
        /**
         * @function openBus 开启监听
         */
        openBus() {
            this.$bus.$on('getColumnList', res => {
                let item = this.menuList[0].children[0];
                this.menuList[0].children = [item];
                this.getColumnList();
            });
            this.$bus.$on('clearMenuActive', res => {
                // this.defaultOpeneds = [];
                this.defaultActive = '';
            });
        },
        handleMenuSelect(key, keyPath) {
            console.log('handleMenuSelect>>>', key, keyPath)
            this.defaultActive = key;
            let keys = String(key).split('-'); // keys = [path, name, style, id]
            let path = keys[0], name = keys[1], 
                style = keys.length > 2 ? keys[2] : '', 
                id = keys.length > 3 ? Number(keys[3]) : 0;
            this.setSessionData();
            this.toPage(path, name, style, id);
        },
        handleMenuOpen(key, keyPath) {
            // console.log('handleMenuOpen>>>', key, keyPath)
            this.defaultOpeneds = keyPath;
            this.setSessionData();
        },
        handleMenuClose(key, keyPath) {
            // console.log('handleMenuClose>>>', key, keyPath)
        },
        /**
         * @function setSessionData 保存页面信息到本地
         */
        setSessionData() {
            let data = {
                openedIndex: this.defaultOpeneds,
                activeIndex: this.defaultActive
            };
            window.sessionStorage.setItem('menuChecked', JSON.stringify(data));
        },
        /**
         * @function toPage 跳转页面方法
         * @param { string } path 页面路径
         * @param { string } name 页面名称
         * @param { string } style 页面样式
         */
        toPage(path, name, style, id) {
            let query = path == '/pageNull' ? { style: style, id: id } : {}
            let item = {
                data: {
                    name: name,
                    path: path == '/pageNull' ? '/pageModuleSet' : path,
                    query: query
                },
                flag: false
            };
            this.$store.commit('setNavData', item);
            this.$router.push({ path: path, query: query });
        },
        /**
         * @function updateColumnList 更新栏目数据
         */
        updateColumnList(data) {
            this.$store.commit('setColumnList', data);
        }
    }
}
</script>
<style lang="scss" scoped>
@import './MenuComponent.scss';
</style>
<style lang="scss">
.menu-container {
    .el-menu-item, .el-submenu__title {
        height: 43px;
        line-height: 43px;
    }
    .el-menu-item:focus {
        background: #fff !important;
    }
    .el-menu-item:hover, .el-submenu__title:hover {
        color: #fff !important;
        i {
            color: #fff !important;
        }
    }
    .el-menu-item.is-active {
        background: #fff !important;
        &:hover {
            color: #4994FB !important;
            i {
                color: #4994FB !important;
            }
        }
    }
    .secondmenubox {
        > .el-menu {
            background: #0C1D4B;
            .el-menu-item {
                background: #0C1D4B !important;
            }
            .el-menu-item.is-active {
                background: #fff !important;
            }
        }
    }
    .thirdmenubox {
        // > .el-menu {
        //     background: #F2F2F2;
        // }
    }
    .fourmenubox {
        // > .el-menu {
        //     background: #eee;
        // }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/menu/MenuComponent.vue